import { ThemeColorVariable, ThemeSpaceVariable } from "@caspeco/casper-ui-library.base-ui.theme";
// eslint-disable-next-line import/no-named-as-default
import styled from "styled-components";

interface IStyledSingleCartRow {
	$borderBottom: boolean;
}

export const StyledSingleCartRow = styled.article<IStyledSingleCartRow>`
	${(props) => {
		return props.$borderBottom ? `border-bottom: 1px solid ${ThemeColorVariable.OnSurfaceBorder};` : "";
	}};

	display: flex;
	flex-direction: column;
	justify-content: space-between;
	padding: ${ThemeSpaceVariable.Medium} 0;
	user-select: none;
`;
